import './main.css';
import { FaGithub, FaWhatsapp ,FaInstagram, FaLinkedin, FaBars, FaTimes} from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Conteudo from "../Conteudo";


export default function Main(){
    AOS.init({
        duration: 600,
        delay: 200,
    });


    


    function abrirModalMobile(){
        let modal = document.querySelector('.modalMenuMobile');

        modal.style.right="0";
       
    }


    function fecharModalMobile(){
        let modal = document.querySelector('.modalMenuMobile');

        modal.style.right="-350px"
      
    }



    return(
        <>
        <div className="main">
            <header>
                <div className='logo'> <h2>Charles Lemes</h2> </div>

                <div className='menu-desktop'>
                    <ul>
                        <li> <a href='#sobre'> Sobre </a> </li>
                        <li> <a href='#projetos'> projetos </a> </li>
                        <li> <a target="_blank" href='https://github.com/charleeslemes/PortfolioReact'> Código do site </a> </li>
                    </ul>

                </div>


                <div className='menu-mobile'>
                   <div onClick={abrirModalMobile} className='icon-menu'> < FaBars/> </div>
                    <div className='modalMenuMobile'>
                   <div onClick={fecharModalMobile}><FaTimes/></div> 
                    <ul>
                        <li> <a href='#sobre'>  Sobre  </a> </li>
                        <li> <a href='#projetos'> projetos </a> </li>
                        <li> <a target="_blank" href='https://github.com/charleeslemes/PortfolioReact'> Código do site </a> </li>

                        
                    </ul>
                    
                    </div>
                </div>

            </header>

            <div className='bio1'data-aos="flip-left"  >
            
            <div className='img-autor'></div>

            <h1 > Olá, Sou Charles Gabriel Lemes</h1>
            <p>Desenvolvedor Fron-end</p>

            <ul>
                <li><a target="_blank" href='https://github.com/charleeslemes'><FaGithub /></a></li>
                <li><a target="_blank" href='https://www.linkedin.com/in/charles-lemes-96a2a4211/'><FaLinkedin /></a></li>
                <li><a target="_blank" href='https://www.instagram.com/charleeslemes/'><FaInstagram /></a></li>
                <li><a target="_blank" href='https://wa.me/5541995458166'><FaWhatsapp/></a></li>
            </ul>

           

            </div>{/* bio1 */}


            <div className='seta'></div>


        </div>

        

        <Conteudo/>

        </>

    )
}